import React from "react";

import apple from "assets/graphics/icons/apple--white.svg";
import android from "assets/graphics/icons/android--white.svg";

import "features/application/congrats/view.scss";

const CongratsView = () => (
  <div className="congrats__content">
    <h1 className="application__headline">Now Download Our App!</h1>
    <p className="form__description--large" style={{ opacity: 1 }}>
      <span style={{ opacity: 0.8 }}>
        Please log-in to the mobile app, so we can notify you when our team
        approves your membership.
      </span>
    </p>
    <p className="download__information">Download here</p>
    <div className="download__stores">
      <a
        className="download__store"
        href="https://apps.apple.com/us/app/parlor-social-club/id1473428896"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "iosVisited" })}
      >
        <img src={apple} alt="apple" />
      </a>
      <a
        className="download__store"
        href="https://play.google.com/store/apps/details?id=social.parlor.app"
        target="blank"
        onClick={() => window.dataLayer.push({ event: "androidVisited" })}
      >
        <img src={android} alt="android" />
      </a>
    </div>
  </div>
);

export default CongratsView;
